import { useState } from 'react'

import * as authApi from '@/features/auth/auth-api'
import { useAuth } from '@/features/auth/auth-context'
import { clearImpersonationToken } from '@/shared/api/client'

export function ImpersonationBanner() {
  const { user } = useAuth()
  const [leaving, setLeaving] = useState(false)

  const impersonation = user?.impersonation

  if (!impersonation) {
    return null
  }

  const leave = async () => {
    setLeaving(true)

    try {
      await authApi.logout()
    } catch {
      // Токен всё равно бросаем: даже если запрос не дошёл, вкладка закрывается.
    }

    clearImpersonationToken()
    // Вкладку открыла админка — закрываем её. Если браузер не дал (или это
    // не открытая скриптом вкладка), через мгновение уводим на страницу входа.
    window.close()
    setTimeout(() => {
      window.location.href = '/login'
    }, 100)
  }

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-black"
      role="alert"
    >
      <span>
        Вы в кабинете {user?.name}. Вход выполнен администратором {impersonation.admin_name}.
      </span>
      <button
        className="rounded bg-black/80 px-3 py-1 text-white disabled:opacity-60"
        disabled={leaving}
        onClick={() => void leave()}
        type="button"
      >
        Выйти
      </button>
    </div>
  )
}
